import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import TransactionSummary from 'components/Invoice/TransactionSummary';
import TerminalDetails from 'components/Invoice/TerminalDetails';
import Invoices from 'components/Invoice/Invoices';
import BankSummary from 'components/Invoice/BankSummary';
import BankTransactions from 'components/Invoice/BankTransactions';
import MerchantTransactions from 'components/Invoice/MerchantTransactions';
import BankTerminalDetails from 'components/Invoice/BankTerminalDetails';
import BankEMI from 'components/Invoice/BankEMI';
// import FinanceTransactions from 'components/Invoice/FinanceTransactions';
// import FinanceInvoice from 'components/Invoice/FinanceInvoice';
// import FinancePayments from 'components/Invoice/FinancePayments';
//import TerminalInstallations from 'components/Invoice/TerminalInstallations'
import {BeatLoader} from "react-spinners";
import axios from "axios";
import $ from "jquery";
import NotificationSystem from "react-notification-system";
import {css} from "@emotion/core";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import {style} from "variables/Variables.jsx";
import ModalD from "react-awesome-modal";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from "react-virtualized";
import {connect}  from  "react-redux";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const overrides = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
    float:right;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}

const months = new Array("01", "02", "03", "04", "05", "06",
    "07", "08", "09", "10", "11", "12"
);
var timestamp = new Date().getTime();
var monthOptions = [];
var monthName = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
var d = new Date();
d.setDate(1);
for (var i=0; i<=22; i++) {
    //console.log(monthName[d.getMonth()] + ' ' + d.getFullYear());
    monthOptions.push({ value: months[d.getMonth()]+d.getFullYear(), label: monthName[d.getMonth()] + ' ' +d.getFullYear() })
    d.setMonth(d.getMonth() - 1);
}
// for(var i=0; i<=11; i++){
//     let date2 = new Date();
//     let monthd = date2.setMonth(date2.getMonth() -i);
//     date2 = date2.toDateString();
//     date2 = new Date(date2);
//     let month2 = getMonth(date2);
//     let year2 = date2.getFullYear();
//     let monthName2 = monthNames[date2.getMonth()];
//     var isDisable = true;
//     if(month2 == '06' || month2 == '07'){
//         isDisable = false;
//     }
//
//     monthOptions.push({ value: month2+year2, label: monthName2+' '+year2 })
// }
//console.log("1stmothoption");
//console.log(monthOptions);
function getLstDayOfMonFnc(date) {
    return new Date(date.getFullYear(), date.getMonth(), 0).getDate()
}
class Transaction extends Component{
    // constructor(props) {
    //     super(props);
        state ={
            tabsPermissionsArray:[],
            allTabs:["invoice_merchants", "invoice_banks", "invoice_finance"],
            tabsPermissions:[],
            matchedTabs:'',
            merchantList:[],
            chainList:[],
            merchantID:[],
            chainID:[],
            monthID: '042020',
            is_download:true,
            user_id:'',
            merchant_name:'Reliance Retail Limited',
            acqBankList: [{value: '', label: 'All'}],
            acqBankValue: null,
            acq_bank_id: [],
            selected_tab:'Summary',
            merchantValue:null,
            chainValue:null,
            bankValue:null,
            monthValue: {value: '042020', label: 'April 2020'},
            storeID:[],
            storeValue:'',
            storeList:[],
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            model_visible: false,
            file_url: '',
            rfile: '',
            newErrorModel: false,
        //}
        }
        componentWillMount() {
            this.props.currentMenu("unipaynext");
            }
    componentDidMount() {
        const tabsPermissions = localStorage.tabsPermissions;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            tabsPermissionsArray:tabsPermissions,
            user_id:decoded._id,
            email:decoded.email
        });
        this.tabsPermission();
        this._getAllMerchants();

        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this._getAcqBanks();
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            //this.get_filtered_data('', '', this.state.monthID);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Acquiring Bank') {

            var optionSelected = {"value":arrayCode, "label":"" }
            this.changeBank(optionSelected);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: false,
            })
        }
    }



    _getAcqBanks(){
        axios.get(config.get('API_URL') + '/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if (Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL') + '/reports/get-merchant/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
            response.data.map((merchant,index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
            }
        });
    }
    changeMerchant(login_type, optionSelected) {
        let value = '';
        let midArray = [];
        if (optionSelected.length < 1) {
            value = null;
            midArray = '';
        } else {
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID: midArray,
            chainID:[],
            merchantValue:optionSelected,
            chainValue: [],
            storeID:[],
            storeValue: []
        });
        setTimeout(function(){
        this.refs.childSummary.get_filtered_data_merchant(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
            }
        if(this.state.selected_tab=='childMerchantTransaction') {
            this.refs.childMerchantTransaction.get_filtered_merchant_tra(this.state.merchantID, this.state.chainID, this.state.storeID, value);
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(midArray,this.state.chainID, this.state.storeID,this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(midArray, this.state.chainID, this.state.storeID, this.state.monthID);
        // }

        if (login_type == '') {
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }
    }


    changeChain(login_type, optionSelected) {
        let value = '';
        let cidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            cidArray = '';
        } else {
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
                });
            }
            this.setState({
            chainID: cidArray,
            chainValue: optionSelected,
            storeID: [],
            storeValue: []
        });
        setTimeout(function(){
        this.refs.childSummary.get_filtered_data_merchant(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        }
        if(this.state.selected_tab=='childMerchantTransaction') {
            this.refs.childMerchantTransaction.get_filtered_merchant_tra(this.state.merchantID, this.state.chainID, this.state.storeID, value);
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID,this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID);
        // }




        if (login_type == '') {
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
    }

    }
    getChain(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-chain/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            let chalinList = [];
            this.setState({chainID: []});
            response.data.map((chain, index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList: chalinList
            })
        });
    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }

            }).then(response => {
            let storeList = [];
            this.setState({storeID: []});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList: storeList,
                is_store_loading: false
            })
        });
        }

    changeStore(login_type, optionSelected) {
        let value = '';
        let sidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            sidArray = '';
        } else {
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');
        }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        setTimeout(function(){
        this.refs.childSummary.get_filtered_data_merchant(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );

        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        }
        if(this.state.selected_tab=='childMerchantTransaction') {
            this.refs.childMerchantTransaction.get_filtered_merchant_tra(this.state.merchantID, this.state.chainID, this.state.storeID, value);
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID);
        // }

    }



    changeMonth(type, optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        //alert(value);
        this.setState({
            monthID: value,
            monthValue:optionSelected,
        });
        if(type=='merchant'){

            this.refs.childSummary.get_filtered_data_merchant(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            if(this.state.selected_tab=='TerminalDetails') {
                this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            }
            if(this.state.selected_tab=='childMerchantTransaction') {
                this.refs.childMerchantTransaction.get_filtered_merchant_tra(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            }
            // if(this.state.selected_tab=='DeInstallation') {
            //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            // }
            // if(this.state.selected_tab=='Invoices') {
            //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            // }
            }
        if(type=='bank'){

                this.refs.bankChildSummary.get_filtered_data_bank(this.state.acq_bank_id,value );

            if(this.state.selected_tab=='BankTransaction') {
                this.refs.bankChildTransaction.get_filtered_bank_tra_data(this.state.acq_bank_id, value);
            }
            if(this.state.selected_tab=='BankTerminal') {
                this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(this.state.acq_bank_id, value);
            }
            // if(this.state.selected_tab=='BankEMI') {
            //     this.refs.bankChildEMI.get_filtered_bank_emi(this.state.acq_bank_id, value);
            // }
            }
        }

    downLoadExel(e){
        var postDatam = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            month: this.state.monthID,
        }
        if (this.state.merchantID.length > 0 || this.state.chainID.length > 0 || this.state.storeID.length > 0) {
            this.setState({
                is_download: false,
                model_visible: true,
                file_url: '',
                rfile: ''
            });
            let xhrBank = $.ajax({
                url:config.get('API_URL')+ "/invoice/merchant_download_excel",
                type: "POST",
                data: postDatam,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (response, status, xhr) {
                    let blob = new Blob([response], {
                        type: "octet/stream"
                    });
                    let fileName = timestamp + '.gz';
                    //let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                    let rfile = fileName.replace(/\"/g, "");
                    //console.log(fileName)
                    // let a = document.createElement('a');
                    // let url = window.URL.createObjectURL(blob);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    let url = window.URL.createObjectURL(blob);
                    this.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })

        }
        else {
            alert("Please select Merchant/Chain/Store to download Excel");
        }
    }
    cancelReq(){
        this.state.xhr.abort();
        this.setState({
            is_download:true
        })
    }
    tabsPermission(){
        const token = localStorage.usertoken;
        let tabsPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllaccessPermissions = decoded_permission.accessPermissions;
        AllaccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Tab'){
                tabsPermissions.push(permissionName.access_name);
            }
        });
        this.setState({
            tabsPermissions:tabsPermissions,
        });
        this.getMatch(tabsPermissions,this.state.allTabs);

    }
    getMatch(a, b) {
        var matches = [];

        for ( var i = 0; i < a.length; i++ ) {
            for ( var e = 0; e < b.length; e++ ) {
                if ( a[i] == b[e] ) matches.push( a[i] );
            }
        }
        //alert(matches.length);
        this.setState({
            matchedTabs:matches.length
        })
    }
    triggerChildAlert(){
        this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"TerminalDetails",
        })
    }
    triggerChildAlertMerchantSummary(){
        this.refs.childSummary.get_filtered_data_merchant(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"MerchantSummary",
        })
    }
    triggerChildAlertMerchantTransaction(){
        this.refs.childMerchantTransaction.get_filtered_merchant_tra(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"childMerchantTransaction",
        })
    }
    triggerChildAlertInvoices(){
        this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"Invoices",
        })
    }
    triggerChildAlertBankTransaction(){
        this.refs.bankChildTransaction.get_filtered_bank_tra_data(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankTransaction",
        })
    }
    triggerChildAlertBankSummary(){
        this.refs.bankChildSummary.get_filtered_data_bank(this.state.acq_bank_id, this.state.monthID );
        this.setState({
            selected_tab:"BankSummary",
        })
    }
    triggerChildAlertTerminalRental(){
        this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankTerminal",
        })
    }
    triggerChildAlertBankEMI(){
        this.refs.bankChildEMI.get_filtered_bank_emi(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankEMI",
        })
    }


    downLoadExelBank(e){
        var postDataBank = {
            banks_codes: this.state.acq_bank_id,
            month: this.state.monthID,
        }
        if (this.state.acq_bank_id.length < 1) {
            //this.props.handleClick("tr", 3, "Please select a Bank")
            alert("Please select Bank to download Excel");
        }
        else {
            this.setState({
                is_download: false,
                model_visible: true,
                file_url: '',
                rfile: ''
            });
            let xhrBank = $.ajax({
                url:config.get('API_URL')+ "/invoice/bank_download_excel",
                type: "POST",
                data: postDataBank,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (response, status, xhr) {
                    let blob = new Blob([response], {
                        type: "octet/stream"
                    });
                    let fileName = timestamp + '.gz';
                    //let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                    let rfile = fileName.replace(/\"/g, "");
                    //console.log(fileName)
                    // let a = document.createElement('a');
                    // let url = window.URL.createObjectURL(blob);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    let url = window.URL.createObjectURL(blob);
                    this.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })
        }
    }
    downloadFile(e) { //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        //this.state.xhrBank.abort();
        this.setState({
            model_visible: false,
            is_download:true
        });
    }


    changeBank(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        const label = optionSelected === null ? '' : optionSelected.label;
        this.setState({
            acq_bank_id:value,
            bankValue:optionSelected,
            bank_name: label,
        });
        // console.log("hgdhsgfhsdfsdfsdf");
        // console.log(value);
        this.refs.bankChildSummary.get_filtered_data_bank(value, this.state.monthID );
        if(this.state.selected_tab=='BankTransaction') {
            this.refs.bankChildTransaction.get_filtered_bank_tra_data(value, this.state.monthID);
        }
        if(this.state.selected_tab=='BankTerminal') {
            this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(value, this.state.monthID);
        }
        // if(this.state.selected_tab=='BankSummary') {
        //
        // }
        if(this.state.selected_tab=='BankEMI') {
            //this.refs.bankChildEMI.get_filtered_bank_emi(value, this.state.monthID);
        }
        //this.get_bank_name(value);
    }
    handleClickRerunTask(forceRun, run_type, e) {
        var month_year = this.state.monthID.match(/.{1,2}/g);
        var month = month_year[0].replace(/^0+/, '');
        var year = '20'+month_year[1];
        var firstday =   new Date(year, month , 1).getDate();
        var lastday =   getLstDayOfMonFnc(new Date(year, month, 15))
        var from = year+'-'+month_year[0]+'-'+firstday;
        var to = year+'-'+month_year[0]+'-'+lastday;

        if (forceRun == 1) {
            forceRun = 1
        } else {
            forceRun = 0
        }

        axios.post(config.get('API_URL')+'/invoice/rerun_process_log_task/',{
                user_email: this.state.email,
                merchantID: this.state.merchantID,
                chainID: this.state.chainID,
                storeID: this.state.storeID,
                acqBankID: this.state.acq_bank_id,
                from:  from,
                to: to,
                task_identifier: "pricing",
                force_run: forceRun,
                run_type: run_type,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
             //console.log(response);
            // console.log(response.data.extra_data.error)
            if (response.data.extra_data.error === 'failed-tasks') {
                var array = response.data.extra_data.tasks
                var ts = array.join(', ');
                //console.log(ts);
                this.setState({
                    force_run: 1,
                    etype: response.data.extra_data.error,
                    tasks_lists: ts
                })
                this.toggleNewErrorModel(response.data);
            }
            if(response.data.error){
                alert(response.data.error);
            }
            else {
                alert("Invoicing process started. Please check process log for status");
            }


        }).catch( err => {
            console.log(err);
        });
        this.setState({
            newRiseModel: false
        })
    }
    toggleNewErrorModel(data) {
        this.setState({
            newErrorModel: true,
            error_data: data
        })
    }

    // closeModal() {
    //     this.setState({
    //         newErrorModel: false
    //     });
    // }

    closeModalAndRun() {
        this.handleClickRerunTask(1, 'manual');
        this.setState({
            newErrorModel: false
        });
    }
    render() {

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if (rows.length !== undefined) {
                no_of_rows = rows.length;
                if (no_of_rows < 9) {
                    drop_down_heigth = 40 * no_of_rows;
                } else {
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({key, index, isScrolling, isVisible, style}) => (
                <div key={key} style={style}>{rows[index]}</div>
            );
            return (
                <List
                    style={{width: '100%'}}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        let merchantTab='';
        let merchantTabPane='';
        let bankTab='';
        let bankTabPane='';
        let financeTab='';
        let financeTabPane='';
        let merchantComponent='';
        let bankComponent='';
        let financeComponent='';
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "34px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "34px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),

        };
        let is_any_tab = 'N';
        if(this.state.tabsPermissions.includes("invoice_merchants")===true){
            is_any_tab = 'Y';
            merchantTab = (
                <Tab style={{ }}>Merchants</Tab>
            );
            merchantTabPane = (
                <TabPanel>
                    <div className="tansactionTabs filterpane">
                        {this.state.merchant_list_box===true?
                            <div className="col-md-2 filter-bottom5 ">
                            <label>Merchants</label>
                                <ReactMultiSelectCheckboxes name="merchants"
                                                            isMulti
                                                            components={{MenuList}}
                                    value={this.state.merchantValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeMerchant.bind(this, '')}
                                    options={this.state.merchantList}
                                                            placeholderButtonLabel="Select [Merchant]"
                            />

                            <div className="clearfix"></div>
                        </div>: null }
                        {this.state.chain_list_box===true?
                            <div className="col-md-2 filter-bottom5 padd-5">
                            <label> Chain </label>
                                <ReactMultiSelectCheckboxes name="chain"
                                                            isMulti
                                                            components={{MenuList}}
                                    value={this.state.chainValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeChain.bind(this, '')}
                                    options={this.state.chainList}
                                                            placeholderButtonLabel="Select [Chain]"
                            />
                             <div className="clearfix"></div>
                        </div>: null }
                        {this.state.store_list_box===true?
                            <div className="col-md-2 filter-bottom5 padd-5">
                            <label> Store </label>
                                <ReactMultiSelectCheckboxes name="store"
                                                            isMulti
                                                            isLoading={this.state.is_store_loading}
                                                            components={{MenuList}}
                                    value={this.state.storeValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeStore.bind(this, '')}
                                    options={this.state.storeList}
                                                            placeholderButtonLabel="Select [Store]"
                            />
                            <div className="clearfix"></div>
                        </div>: null }

                        <div className="col-md-2">
                            <label > Month </label>
                            <Select name="month"
                                    value={this.state.monthValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'merchant')}
                                    options={monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-2 downLoad-con">
                            <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.downLoadExel.bind(this)}>Download Excel</a>
                        </div>
{/*                         <div className="col-md-2 downLoad-con"> */}
{/*                             <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.handleClickRerunTask.bind(this, 0, 'manual')}>Run Invoicing</a> */}
{/*                         </div> */}
                        <div className="clearfix"></div>
                    </div>
                    <Tabs forceRenderTabPanel defaultIndex={0}>
                        <TabList>
                            <Tab onClick={()=>this.triggerChildAlertMerchantSummary()}>Summary</Tab>
                            <Tab onClick={()=>this.triggerChildAlert()}>Terminal Details</Tab>
                            <Tab onClick={()=>this.triggerChildAlertMerchantTransaction()}>Transaction</Tab>
                            {/*<Tab onClick={()=>this.triggerChildAlertInstallation()}>Installations</Tab>*/}
                            {/*<Tab onClick={()=>this.triggerChildAlertDeInstallation()}>Denstallations</Tab>*/}
                            {/*<Tab onClick={()=>this.triggerChildAlertInvoices()}>Invoices</Tab>*/}
                            {/*<Tab>Credit Notes</Tab>*/}

                        </TabList>
                        <TabPanel>
                            <TransactionSummary ref="childSummary"/>
                        </TabPanel>
                        <TabPanel>
                            <TerminalDetails ref="childTerminal"/>
                        </TabPanel>
                        <TabPanel>
                            <MerchantTransactions ref="childMerchantTransaction"/>
                        </TabPanel>
                        {/*<TabPanel>*/}
                        {/*    <TerminalInstallations ref="childInstallation"/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel>*/}
                        {/*    <TerminalDeInstallations ref="childDeInstallation"/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel>*/}
                        {/*    <Invoices ref="childInvoices"/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel>*/}
                        {/*    <p>Credit Notes</p>*/}
                        {/*</TabPanel>*/}
                    </Tabs>
                </TabPanel>
            );
            merchantComponent=(

                <Tabs forceRenderTabPanel defaultIndex={0}>
                    <div className="tansactionTabs filterpane">
                        {this.state.merchant_list_box===true?
                            <div className="col-md-2 filter-bottom5 ">
                            <label >Merchants</label>
                                <ReactMultiSelectCheckboxes name="merchants"
                                                            isMulti
                                                            components={{MenuList}}
                                    value={this.state.merchantValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeMerchant.bind(this, '')}
                                    options={this.state.merchantList}
                                                            placeholderButtonLabel="Select [Merchant]"
                            />

                            <div className="clearfix"></div>
                        </div> :null }
                        {this.state.chain_list_box===true?
                            <div className="col-md-2 filter-bottom5 padd-5">
                            <label > Chain </label>
                                <ReactMultiSelectCheckboxes name="chain"
                                                            isMulti
                                                            components={{MenuList}}
                                    value={this.state.chainValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeChain.bind(this, '')}
                                    options={this.state.chainList}
                                                            placeholderButtonLabel="Select [Chain]"
                            />
                            <div className="clearfix"></div>
                        </div> : null }
                        {this.state.store_list_box===true?
                            <div className="col-md-2 filter-bottom5 padd-5">
                            <label> Store </label>
                                <ReactMultiSelectCheckboxes name="store"
                                                            isMulti
                                                            isLoading={this.state.is_store_loading}
                                                            components={{MenuList}}
                                    value={this.state.storeValue}
                                                            styles={customStyles} className="report-listbox"
                                    isClearable={false}
                                                            onChange={this.changeStore.bind(this, '')}
                                    options={this.state.storeList}
                                                            placeholderButtonLabel="Select [Store]"
                            />
                            <div className="clearfix"></div>
                        </div> : null }
                        <div className="col-md-2">
                            <label> Month </label>
                            <Select name="month"
                                    value={this.state.monthValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'merchant')}
                                    options={monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-2 downLoad-con">
                            <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.downLoadExel.bind(this)}>Download Excel
                            </a>
                        </div>
{/*                         <div className="col-md-2 downLoad-con"> */}
{/*                             <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.handleClickRerunTask.bind(this, 0, 'manual')}>Run Invoicing</a> */}
{/*                         </div> */}
                        <div className="clearfix"></div>
                    </div>
                    <TabList>
                        <Tab onClick={()=>this.triggerChildAlertMerchantSummary()}>Summary</Tab>
                        <Tab onClick={()=>this.triggerChildAlert()}>Terminal Details</Tab>
                        <Tab onClick={()=>this.triggerChildAlertMerchantTransaction()}>Transaction</Tab>
                        {/*<Tab onClick={()=>this.triggerChildAlertDeInstallation()}>Denstallations</Tab>*/}
                        {/*<Tab onClick={()=>this.triggerChildAlertInvoices()}>Invoices</Tab>*/}
                        {/*<Tab>Credit Notes</Tab>*/}

                    </TabList>
                    <TabPanel>
                        <TransactionSummary ref="childSummary"/>
                    </TabPanel>
                    <TabPanel>
                        <TerminalDetails ref="childTerminal"/>
                    </TabPanel>
                    <TabPanel>
                        <MerchantTransactions ref="childMerchantTransaction"/>
                    </TabPanel>
                    {/*<TabPanel>*/}
                    {/*    <TerminalInstallations ref="childInstallation"/>*/}
                    {/*</TabPanel>*/}
                    {/*<TabPanel>*/}
                    {/*    <TerminalDeInstallations ref="childDeInstallation"/>*/}
                    {/*</TabPanel>*/}
                    {/*<TabPanel>*/}
                    {/*    <TerminalInstallations ref="childInstallation"/>*/}
                    {/*</TabPanel>*/}
                    {/*<TabPanel>*/}
                    {/*    <Invoices ref="childInvoices"/>*/}
                    {/*</TabPanel>*/}
                    {/*<TabPanel>*/}
                    {/*    <p>Credit Notes</p>*/}
                    {/*</TabPanel>*/}
                </Tabs>

            );
        }
        if(this.state.tabsPermissions.includes("invoice_banks")===true){
            is_any_tab = 'Y';
            bankTab = (
                <Tab style={{ }}>Banks</Tab>
            );
            bankTabPane = (
                <TabPanel>
                    <div className="tansactionTabs filterpane">
                        {this.state.acq_bank_list_box===true?
                        <div className="col-md-3">
                            <label> Banks</label>
                            <Select name="acq_bank_id"
                                    value={this.state.bankValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeBank.bind(this)}
                                    options={this.state.acqBankList}
                                // defaultValue={{ label: "All", value: '' }}
                                    placeholder="All"
                            />
                            <div className="clearfix"></div>
                        </div> : null }
                        <div className="col-md-3">
                            <label> Month </label>
                            <Select name="month"
                                    value={this.state.monthValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'bank')}
                                    options={monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-2 downLoad-con">
                            <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.downLoadExelBank.bind(this)}>Download Excel

                            </a>
                            {/*{!this.state.is_download?*/}
                            {/*    <p><ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>Preparing for download... <a href="#" onClick={this.cancelReqBank.bind(this)} data-tip="Cancel Request"><i className="fa fa-ban" aria-hidden="true"></i></a></p>:null*/}
                            {/*}*/}

                        </div>
{/*                         <div className="col-md-2 downLoad-con"> */}
{/*                             <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.handleClickRerunTask.bind(this, 0, 'manual')}>Run Invoicing</a> */}
{/*                         </div> */}
                        <div className="clearfix"></div>
                    </div>
                    <Tabs forceRenderTabPanel defaultIndex={0}>
                        <TabList>
                            <Tab onClick={()=>this.triggerChildAlertBankSummary()}>Summary</Tab>
                            <Tab onClick={()=>this.triggerChildAlertBankTransaction()}>Transactions</Tab>
                            <Tab onClick={()=>this.triggerChildAlertTerminalRental()}>Terminal Rental</Tab>
                            {/*<Tab onClick={()=>this.triggerChildAlertBankEMI()}>EMI</Tab>*/}
                         </TabList>
                        <TabPanel>
                            <BankSummary ref="bankChildSummary"/>
                        </TabPanel>
                        <TabPanel>
                            <BankTransactions ref="bankChildTransaction"/>
                        </TabPanel>
                        <TabPanel>
                            <BankTerminalDetails ref="bankChildTerminalRental"/>
                        </TabPanel>
                        {/*<TabPanel>*/}
                        {/*    <BankEMI ref="bankChildEMI"/>*/}
                        {/*</TabPanel>*/}
                        {/*<TabPanel>*/}
                        {/*    <p>Credit Notes</p>*/}
                        {/*</TabPanel>*/}
                    </Tabs>
                </TabPanel>
            );
            bankComponent=(
                <Tabs forceRenderTabPanel defaultIndex={0}>
                    <div className="tansactionTabs filterpane top10">
                        {this.state.acq_bank_list_box===true?
                        <div className="col-md-3">
                            <label> Banks </label>
                            <Select name="acq_bank_id"
                                    value={this.state.bankValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeBank.bind(this)}
                                    options={this.state.acq_bank_list}
                                // defaultValue={{ label: "All", value: '' }}
                                    placeholder="All"
                            />
                            <div className="clearfix"></div>
                        </div> : null }

                        <div className="col-md-3">
                            <label> Month </label>
                            <Select name="month"
                                    value={this.state.monthValue}
                                    styles={customStyles} className="chainLists"
                                    isClearable={false}
                                    onChange={this.changeMonth.bind(this, 'bank')}
                                    options={monthOptions}
                                    defaultValue={{label: "April 2020", value: '042020'}}
                                    placeholder="Months"
                            />
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-md-2 downLoad-con">
                            <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.downLoadExelBank.bind(this)}>Download Excel

                            </a>

                        </div>
{/*                         <div className="col-md-2 downLoad-con"> */}
{/*                             <a href="#" className="addButton downloadExcelButton" role="button" onClick={this.handleClickRerunTask.bind(this, 0, 'manual')}>Run Invoicing</a> */}
{/*                         </div> */}
                        <div className="clearfix"></div>
                    </div>
                    <TabList>
                        <Tab onClick={()=>this.triggerChildAlertBankSummary()}>Summary</Tab>
                        <Tab onClick={()=>this.triggerChildAlertBankTransaction()}>Transactions</Tab>
                        <Tab onClick={()=>this.triggerChildAlertTerminalRental()}>Terminal Rental</Tab>
                        {/*<Tab onClick={()=>this.triggerChildAlertBankEMI()}>EMI</Tab>*/}

                    </TabList>
                    <TabPanel>
                        <BankSummary ref="bankChildSummary"/>
                    </TabPanel>
                    <TabPanel>
                        <BankTransactions ref="bankChildTransaction"/>
                    </TabPanel>
                    <TabPanel>
                        <BankTerminalDetails ref="bankChildTerminalRental"/>
                    </TabPanel>
                    {/*<TabPanel>*/}
                    {/*    <BankEMI ref="bankChildEMI"/>*/}
                    {/*</TabPanel>*/}
                </Tabs>
            );
        }
        // if(this.state.tabsPermissions.includes("invoice_finance")===true){
        //     financeTab = (
        //         <Tab style={{ }}>Finance</Tab>
        //     );
        //     financeTabPane = (
        //         <TabPanel>
        //             <Tabs forceRenderTabPanel defaultIndex={0}>
        //                 <TabList>
        //                     <Tab>Transactions</Tab>
        //                     <Tab>Invoices</Tab>
        //                     <Tab>Payments</Tab>
        //                     {/*<Tab>Credit Notes</Tab>*/}
        //
        //                 </TabList>
        //                 <TabPanel>
        //                     <FinanceTransactions/>
        //                 </TabPanel>
        //                 <TabPanel>
        //                     <FinanceInvoice/>
        //                 </TabPanel>
        //                 <TabPanel>
        //                     <FinancePayments/>
        //                 </TabPanel>
        //                 {/*<TabPanel>*/}
        //                 {/*    <BankEMI/>*/}
        //                 {/*</TabPanel>*/}
        //                 {/*<TabPanel>*/}
        //                 {/*    <p>Credit Notes</p>*/}
        //                 {/*</TabPanel>*/}
        //             </Tabs>
        //         </TabPanel>
        //     );
        //     financeComponent=(
        //         <Tabs forceRenderTabPanel defaultIndex={0}>
        //             <TabList>
        //                 <Tab>Transactions</Tab>
        //                 <Tab>Invoices</Tab>
        //                 <Tab>Payments</Tab>
        //                 {/*<Tab>Credit Notes</Tab>*/}
        //
        //             </TabList>
        //             <TabPanel>
        //                 <FinanceTransactions/>
        //             </TabPanel>
        //             <TabPanel>
        //                 <FinanceInvoice/>
        //             </TabPanel>
        //             <TabPanel>
        //                 <FinancePayments/>
        //             </TabPanel>
        //             {/*<TabPanel>*/}
        //             {/*    <BankEMI/>*/}
        //             {/*</TabPanel>*/}
        //             {/*<TabPanel>*/}
        //             {/*    <p>Credit Notes</p>*/}
        //             {/*</TabPanel>*/}
        //         </Tabs>
        //     );
        // }

        return(
          
            <div className="content-invoice pt-5">
                <div className="container-fluid">
                    <div className="row">
                        <NotificationSystem ref="notificationSystem" style={style}/>

                        <div className="col-md-12">
                            <div className="card">
                                <div className="content-invoice ">
                                    {this.state.matchedTabs>1?
                                        <Tabs>
                                            <TabList>
                                                {merchantTab}
                                                {bankTab}
                                                {/*{financeTab}*/}
                                            </TabList>

                                            {merchantTabPane}
                                            {bankTabPane}
                                            {/*{financeTabPane}*/}
                                        </Tabs>:
                                        <div>
                                            {merchantComponent}
                                            {bankComponent}
                                            {/*{financeComponent}*/}
                                            {
                                                is_any_tab=='N'? <div className="col-md-12 top10">You don't have permission to view this Page</div>:null
                                            }
                                        </div>
                                    }
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100"
                                            effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url == '' ?
                                                    <div>
                                                        <p>Generating Excel...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>

                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <ModalD visible={this.state.newErrorModel} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="log-message-content">
                                                {this.state.ts != '' ?
                                                    <div>Tasks: {this.state.tasks_lists}</div> : null
                                                }
                                                {this.state.etype == 'failed-tasks' ?
                                                    <React.Fragment>
                                                        Force to run?
                                                        <div className="col-md-12 pull-right">
                                                            <a href="javascript:void(0);" onClick={() => this.closeModal()}
                                                               className="log-btn-sure">
                                                                No
                                                            </a>
                                                            <a href="javascript:void(0);" onClick={() => this.closeModalAndRun()}
                                                               className="log-btn-sure">
                                                                Yes
                                                            </a>

                                </div>
                                                    </React.Fragment> : null}
                                                {this.state.etype == 'running-tasks' ?
                                                    <React.Fragment>
                                                        Running
                                                    </React.Fragment> : null}
                            </div>
                        </div>
                                    </ModalD>
                    </div>
                </div>
            </div>
                    </div>
                </div>
            </div>
           
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( Transaction );